import { Link } from 'react-router-dom';
import type { PrerequisiteCourseBlock } from '@lms/shared-types';

export function prerequisiteCourseLabel(block: PrerequisiteCourseBlock): string {
  return block.prerequisiteCourseName?.trim() || 'el curso previo';
}

export function PrerequisiteCourseGate({ block }: { block: PrerequisiteCourseBlock }) {
  const courseName = prerequisiteCourseLabel(block);
  const href = `/mis-cursos/${block.prerequisiteCourseId}`;

  return (
    <section className="rounded-xl border border-dash-outline-variant bg-white p-6 shadow-sm">
      <p className="text-sm font-medium text-dash-secondary">Requisito del curso</p>
      <h2 className="mt-1 text-2xl font-semibold text-dash-primary">Curso previo</h2>
      {block.status === 'sin_intento' ? (
        <>
          <p className="mt-3 text-sm text-dash-on-surface-variant">
            Debes rendir la evaluación de {courseName}
          </p>
          <Link
            to={href}
            className="mt-6 inline-flex rounded-lg bg-dash-primary px-4 py-2 text-sm font-medium text-white"
          >
            Ir al curso previo
          </Link>
        </>
      ) : null}
      {block.status === 'en_revision' ? (
        <p className="mt-3 text-sm text-dash-on-surface-variant">Tu evaluación está en revisión</p>
      ) : null}
      {block.status === 'rechazado' ? (
        <>
          <p className="mt-3 text-sm text-dash-on-surface-variant">Tu evaluación fue rechazada</p>
          {block.rejectionReason ? (
            <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" role="status">
              {block.rejectionReason}
            </p>
          ) : null}
          <Link
            to={href}
            className="mt-6 inline-flex rounded-lg bg-dash-primary px-4 py-2 text-sm font-medium text-white"
          >
            Ir al curso previo
          </Link>
        </>
      ) : null}
    </section>
  );
}
